export default "__VITE_ASSET__b78182a6__"